import {
    dispatch
} from '@rematch/core';
import {
    push
} from 'react-router-redux';

import {
    registerUserService,
    activateUserService
} from '../../services/feathers.service';

const initialState = {
    registered: false,
    emailId: null,
    captchaResponse: null,
    registrationError: null
};

export default {
    state: initialState,
    reducers: {
        setError(state, payload) {
            return {
                ...state,
                registrationError: payload
            }
        },
        setCaptchaResponse(state, payload) {
            return {
                ...state,
                captchaResponse: payload
            }
        },
        endRegistration(state, email) {
            return {
                ...state,
                emailId: email,
                registered: true
            }
        },
        clear() {
            return initialState
        }
    },
    effects: {
        async registerAsync(payload, rootState) {
            payload.Str = 'registerUser'
            const user = payload;
            user.captchaResponse = rootState.register.captchaResponse;
            //user.profilePic = "http://res.cloudinary.com/aspenify/image/upload/v1535094547/uhmidgexdzniimugr7h0.jpg"
            user.timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
            try {
                await registerUserService.create(user);
                dispatch.register.endRegistration(user.email);
            } catch (err) {
                dispatch.register.setError(err);
                throw err;
            }
        },
        gotoRegister() {
            dispatch.register.clear();
            return dispatch(push('/register'));
        },
        async activateUser(payload) {
            try {
                await activateUserService.patch(payload, {
                    "isVerified": true,
                });
                dispatch.login.setError(null);
            } catch (err) {
                dispatch.register.setError(err);
            }
        },

    }
}